import { render, staticRenderFns } from "./parent-plans.vue?vue&type=template&id=c9eee49c&"
import script from "./parent-plans.vue?vue&type=script&lang=js&"
export * from "./parent-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports